import { Injectable, inject } from "@angular/core";

import { Utilities } from "@tylertech/shared-module";
import { ApiService } from "@tylertech/core-module";
import { InputParameterService } from "@tylertech/search-module";
import
{
    CheckStockLookupViewModel,
    ExecutionResult,
    ICheckStockLookupService,
    LookupCriteria,
} from "@tylertech/tyler-api-types";

/**
 * TODO - Split this up into API service and front-end service to support ExpressService attribute in Tyler.Api
 */
@Injectable()
export class CheckStockService implements ICheckStockLookupService
{
    private readonly $apiService = inject(ApiService);
    private readonly $inputParameterService = inject(InputParameterService);


    Lookup(criteria: LookupCriteria): Promise<ExecutionResult<CheckStockLookupViewModel[]>>
    {
        return this.$apiService.sendAuth("ICheckStockLookupService/Lookup", criteria);
    }

    lookupByBank(value: string): Promise<CheckStockLookupViewModel[]>
    {
        const criteria: LookupCriteria = <LookupCriteria>{ Parameters: [] };
        if (value)
        {
            if (Utilities.isGuid(value) || !isNaN(parseInt(value)))
            {
                criteria.Parameters.push(
                    this.$inputParameterService.createTextParameter({
                        Label: "BankCodeId",
                        FieldId: "BankCodeId",
                        Value: value,
                    })
                );
            }
            else
            {
                criteria.SearchText = value;
            }
        }
        return this.Lookup(criteria)
            .then(x => x.Result);
    }

    lookupById(value: string): Promise<CheckStockLookupViewModel[]>
    {
        const criteria: LookupCriteria = <LookupCriteria>{ Parameters: [] };
        criteria.Parameters.push(
            this.$inputParameterService.createTextParameter({
                Label: "Id",
                FieldId: "Id",
                Value: value,
            })
        );
        return this.Lookup(criteria)
            .then(x => x.Result);
    }
}
